import axios from "axios";
import { useState } from "react";
import ToastMessage from "../utility/ToastMessage";

const { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Input, FormControl, Text, FormErrorMessage, VStack, HStack, Select } = require("@chakra-ui/react")

export default function UpdateRfidCardNo({
    isOpen,
    onClose,
    user_id,
    id_card_no,
    // fullname,
    // mobile,
    // sex,
    // nid,
    // batch = null,
    // department_id = null,
    // institute_id = null,
    // user_type,
    // designation_id = null,
    apply_id = null,
    // setRefresh = () => { },
}) {
    // const [gateDepartments, setGateDepartments] = useState([]);
    // const [gateDesignations, setGateDesignations] = useState([]);
    const [inputValue, setInputValue] = useState(id_card_no || '');
    // const [gate_department_id, setGateDepartmentId] = useState(null);
    // const [gate_designation_id, setGateDesignationId] = useState(designation_id || null);
    const [isValid, setIsValid] = useState(true);
    const [showResult, setShowResult] = useState(false);
    const [result, setResult] = useState(null);
    const token = localStorage.getItem('my_token');
    let config = {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
    };

    // useEffect(() => {
    //     const innerDepartmentId = getDepartmentId();
    //     setGateDepartmentId(innerDepartmentId);
    //     getGateData();
    // }, []);

    // const getGateData = async () => {
    //     try {
    //         let apiResponse = (await axios.get(`${process.env.REACT_APP_API_URL}/api/get-gate-data`, {
    //             params: {},
    //             headers: config
    //         })).data;

    //         if (apiResponse.code === 200) {
    //             if ((Array.isArray(apiResponse.results.departments) && apiResponse.results.departments.length === 0) ||
    //                 (Array.isArray(apiResponse.results.designations) && apiResponse.results.designations.length === 0)) {
    //                 ToastMessage('error', 'No departments or designations found in Gate Application');
    //             } else if (apiResponse.results?.departments?.error || apiResponse.results?.designations?.error) {
    //                 ToastMessage('error', 'Error fetching departments or designations from Gate Application');
    //             } else {
    //                 setGateDepartments(apiResponse.results.departments || []);
    //                 setGateDesignations(apiResponse.results.designations || []);
    //             }
    //         }
    //     } catch (error) {
    //         ToastMessage('error', 'Something went wrong');
    //     }
    // }

    const handleChange = (e) => {
        const value = e.target.value;

        // Allow only numeric input
        if (!/^\d*$/.test(value)) return;

        setInputValue(value);

        // Validate if it's exactly 6 or 10 digits
        setIsValid((value.length >= 6 && value.length <= 12) || value.length === 0);
    };

    // const getDepartmentId = () => {
    //     if (!department_id && institute_id) {
    //         return parseInt(institute_id) + 100;
    //     }
    //     return department_id;
    // }

    const handleSubmit = () => {
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`
            }
        };

        const params = {
            id_card_no: inputValue,
            apply_id: apply_id
        }

        axios
            .post(`${process.env.REACT_APP_API_URL}/api/update-id-card-no/${user_id}`, params, config)
            .then((response) => {
                ToastMessage('success', 'Successfully Updated');
                handleClose();
            })
            .catch((error) => {
                const { status } = error?.response;

                let message = 'Something went wrong';
                if (status == 422) {
                    message = 'Invalid Input';
                }

                ToastMessage('error', message);
            });
    }

    // const submitToGateApp = () => {
    //     let config = {
    //         headers: {
    //             Accept: 'application/json',
    //             Authorization: `Bearer ${token}`
    //         }
    //     };

    //     const gateParams = {
    //         "Name": fullname,
    //         "FatherName": "",
    //         "OtherComment": null,
    //         "ContactNo": mobile,
    //         "CardNo": inputValue,
    //         "Gender": sex,
    //         "DepartmentId": gate_department_id,
    //         "DesignationId": gate_designation_id,
    //         "NID": nid,
    //         "Remarks": null,
    //         "Roles": 1,
    //         "BatchNo": batch,
    //         "Status": true
    //     }

    //     axios
    //         .post(`${process.env.REACT_APP_API_URL}/api/submit-gate-data`, gateParams, config)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 ToastMessage('success', 'Successfully Updated');
    //                 handleSubmit();
    //                 setResult(response.data.data);
    //                 setShowResult(true);
    //                 setRefresh(true);
    //             } else {
    //                 ToastMessage('error', response.data.message || 'Something went wrong');
    //             }
    //         })
    //         .catch((error) => {
    //             const { status } = error?.response;

    //             let message = 'Something went wrong';
    //             if (status == 422) {
    //                 message = 'Invalid Input';
    //             }

    //             ToastMessage('error', message);
    //         });
    // }

    const handleClose = () => {
        onClose();
    }

    return (
        <>
            <Modal isOpen={isOpen} onClose={handleClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        Set Card No
                    </ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>
                        <FormControl isInvalid={!isValid} onSubmit={handleSubmit}>
                            <VStack spacing={4}>
                                <HStack>
                                    <Text fontWeight="bold">RF Card Number:</Text>
                                    <Input
                                        placeholder="Enter 6 to 12 digits card No"
                                        value={inputValue}
                                        onChange={handleChange}
                                        width="250px"
                                        maxLength={10}
                                    />
                                </HStack>
                                {/* <HStack>
                                    <Text fontWeight="bold">Department:</Text>
                                    <Select
                                        placeholder='Select Department'
                                        onChange={(e) => setGateDepartmentId(e.target.value)}
                                    >
                                        {Array.isArray(gateDepartments) && gateDepartments.length > 0 && gateDepartments.map((department) => (
                                            <option key={department.Key} value={department.Key} selected={department.id === gate_department_id}>
                                                {department.Value}
                                            </option>
                                        ))}
                                    </Select>
                                </HStack>
                                <HStack>
                                    <Text fontWeight="bold">Designation:</Text>
                                    <Select
                                        placeholder='Select Designation'
                                        onChange={(e) => setGateDesignationId(e.target.value)}
                                    >
                                        {Array.isArray(gateDesignations) && gateDesignations.length > 0 && gateDesignations.map((designation) => (
                                            <option key={designation.Key} value={designation.Key} selected={designation.id === gate_designation_id}>
                                                {designation.Value}
                                            </option>
                                        ))}
                                    </Select>
                                </HStack> */}
                                <Button type="submit" colorScheme="blue" isDisabled={!isValid || inputValue.length === 0} onClick={handleSubmit}>
                                    Submit
                                </Button>
                            </VStack>
                            {!isValid && <FormErrorMessage>Input must be within 6 to 12 digits.</FormErrorMessage>}
                        </FormControl>
                        {showResult && (
                            <VStack mt={4} p={4} borderWidth={1} borderRadius='md' bg='gray.50'>
                                <Text fontWeight="bold">Result:</Text>
                                {Object.entries(result).map(([key, value]) => (
                                    <Text key={key}>{key}: {value}</Text>
                                ))}
                            </VStack>
                        )}
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme='gray' mr={3} onClick={handleClose}>
                            Close
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
